import { Injectable } from '@angular/core';
import {Observable, lastValueFrom, firstValueFrom} from "rxjs";
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {DepositPixModel} from "./depositPix.model";

@Injectable({
  providedIn: 'root'
})
export class DepositPixService {

  constructor(private http: HttpClient) { }

  getAccount() : Promise<any>
    {
      return firstValueFrom(this.http.get(`${environment.apiUrl}/account`));
    }

  public searchDeposit(endToEndId: string) : Promise<any>
  {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("endToEndId", endToEndId);
    return lastValueFrom(this.http.get<any>(`${environment.apiUrl}/getdepositdict`, { params: queryParams }));
  }
  public sendDeposit(request : DepositPixModel) : Observable<any>
  {
    return this.http.post<any>(`${environment.apiUrl}/depositDict`,request);
  }
}
